import App from "@templates/App/App.js";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Building from "@modules/navigator/Building/Building.js";
import {gsap} from "gsap";
import {Draggable} from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";

gsap.registerPlugin(ScrollTrigger, Draggable, InertiaPlugin);

const BannerParallax = {
    aspectShift: 0,
    scene: "byty",
    height: 0,
    data: {
        default: {
            headline: {x: 0.4, y: 0.4},
            front: {x: 0.3, y: 0.3},
            middle: {x: 0.2, y: 0.2},
            back: {x: 0.1, y: 0.1},
        },
        byty: {
            headline: {x: 0.3, y: 0.4},
            front: {x: 0.3, y: 0.3},
            middle: {x: 0.2, y: 0.2},
            back: {x: 0.1, y: 0.1},
            bubble: {x: 0.5, y: 0.3},
        },
        medical: {
            headline: {x: 0.4, y: 0.3},
            front: {x: 0.3, y: 0.3},
            middle: {x: 0.2, y: 0.2},
            back: {x: 0.1, y: 0.1},
            bg: {x: 0, y: 0},
        },
    },

    init() {
        this.el = $('[component="BannerParallax"]');
        if (!this.el.length) return;

        const css = getComputedStyle($('body')[0]);
        this.ratio = parseFloat(css.getPropertyValue('--navigator-aspect-ratio'));
        this.zoom = parseInt(css.getPropertyValue('--navigator-parallax-zoom')) / 100;
        this.footerHeight = parseInt(css.getPropertyValue('--footer-height'));

        this.scene = this.el.attr('scene');
        this.headline = this.el.find('[container="headline"]');
        this.canvas = this.el.find('.canvas');
        this.front = this.el.find('.front');
        this.middle = this.el.find('.middle');
        this.back = this.el.find('.back');
        this.bg = this.el.find('.bg');

        this.bind();
        this.resize();

        setTimeout(() => {
            this.resize();
        }, 10)

        if (!App.isDesktop) {
            setTimeout(() => {
                this.scrollToCenter();
            }, 100)
        }
    },

    bind() {
        this.canvas.bind('scroll', (evt) => {
            // this.onDrag(evt.target)
        })

        if (!App.isTachable) {
            document.addEventListener("mousemove", function (e) {
                if (!App.isDesktop) return;
                BannerParallax.parallax(e);
            });
        }

        if (App.isDesktop) {
            $('[component="Header"]').find('a').click((evt) => {
                if (!App.isDesktop) return;
                localStorage.setItem("lastMousePosition", JSON.stringify({x: evt.pageX, y: evt.pageY}));
            })
        }
    },

    onDrag(canvas) {
        const l = canvas.scrollLeft;
        const scroll = this.canvas.find('.scene')[0].getBoundingClientRect();

        const maxL = scroll.width / 10;
        const percentL = canvas.scrollLeft / (scroll.width - window.innerWidth);
        const x = (maxL * percentL) - (maxL / 2);

        const maxT = scroll.height / 10;
        const percentT = canvas.scrollTop / (scroll.height - this.canvas.innerHeight());
        const y = (maxT * percentT) - (maxT / 2);

        this.front[0].style.transform = 'scale(1.12) translate(' + (-x) + 'px ,' + (-y) + 'px)';
        this.middle[0].style.transform = 'scale(1.12) translate(' + (-x * 0.5) + 'px ,' + (-y * 0.6) + 'px)';

        if (Building.svg) {
            Building.svg[0].style.transform = 'scale(1.12) translate(' + (-x * 0.5) + 'px ,' + (-y * 0.6) + 'px)';
        }
    },

    translateY(Y, animate = false) {
        const scene = this.canvas.find('.scene');
        const sceneHeight = scene.outerHeight();
        const canvasHeight = this.canvas.outerHeight();
        this.diff = Math.floor((sceneHeight / this.zoom) - canvasHeight);

        if (this.diff <= 0) return;

        // automatické mapovanie na -diff/2 <-> diff/2
        const shiftY = this.diff * (-Y + window.innerHeight / 2) / window.innerHeight;

        if (animate) {
            scene.css({transition: '0.5s'});
            setTimeout(() => {
                scene.css({transition: ''});
            }, 500)
        }

        scene[0].style.transform = 'translate(-50%, calc(-50% + ' + shiftY + 'px))';

    },

    parallax(evt) {
        this.set(evt.clientX, evt.clientY)
    },

    set(_X, _Y, volume = 10, animate = false) {
        let data = this.data[this.scene];
        // console.log('set', _X, _Y, this.data);

        // 10% automaticky mapovaných na -5 <-> +5
        const x = volume * (-_X + window.innerWidth / 2) / window.innerWidth;
        const y = volume * (-_Y + window.innerHeight / 2) / window.innerHeight;

        const front = {x: x * data.front.x, y: y * data.front.y}
        // this.front[0].style.transform = 'translate(' + front.x + '% ,' + front.y + '%)';
        this.adjust(this.front, front.x, front.y, animate);

        const middle = {x: x * data.middle.x, y: y * data.middle.y}
        // this.middle[0].style.transform = 'translate(' + middle.x + '% ,' + middle.y + '%)';
        this.adjust(this.middle, middle.x, middle.y, animate);

        const back = {x: x * data.back.x, y: y * data.back.y}
        // this.back[0].style.transform = 'translate(' + back.x + '% ,' + back.y + '%)';
        this.adjust(this.back, back.x, back.y, animate);

        const headline = {x: x * data.headline.x, y: y * data.headline.y}
        // this.headline.find('.holder')[0].style.transform = 'translate(' + headline.x + '% ,' + headline.y + '%)';
        this.adjust(this.headline.find('.holder'), headline.x, headline.y, animate);

        if (Building.svg) {
            // Building.svg[0].style.transform = 'translate(' + middle.x + '% ,' + middle.y + '%)';
            this.adjust(Building.svg, middle.x, middle.y, animate);
        }

        if (data.bg) {
            const bg = {x: x * data.bg.x, y: y * data.bg.y}
            // this.bg[0].style.transform = 'translate(' + bg.x + '% ,' + bg.y + '%)';
            this.adjust(this.bg, bg.x, bg.y, animate)
        }

        if (this.scene === 'default') return;

        this.translateY(_Y);

    },

    adjust(el, X, Y, animate = false) {
        if (animate) {
            gsap.to(el, {x: X, y: Y})
        } else {
            el[0].style.transform = 'translate(' + X + '% ,' + Y + '%)';
        }
    },

    resize() {
        if (!this.el || !this.el.length) return;
        this.reset();

        let mousePos = JSON.parse(localStorage.getItem("lastMousePosition"));
        if (mousePos && App.isDesktop) this.set(mousePos.x, mousePos.y);
        else this.translateY(mousePos && this.translateY(mousePos.y));

        if (this.canvas.innerWidth() / this.canvas.innerHeight() > this.ratio) {
            this.canvas.find('.scene').removeClass('vertical');
        } else {
            this.canvas.find('.scene').addClass('vertical');
        }

        this.el.removeAttr('style').css({height: window.innerHeight});

        if (!App.isDesktop) {
            this.scrollToCenter(false);
        }
    },

    scrollToCenter(animate = true) {
        let shift;
        if (this.scene === 'byty') {
            shift = App.isMobile ? 0.50 : 0.42;
        } else if (this.scene === 'medical') {
            shift = 0.58;
        } else {
            shift = 0.34;
        }
        this.scrollTo(shift, animate);
    },

    scrollTo(shift, animate) {
        const left = this.canvas.find('.scene').outerWidth() * shift;
        if (animate) gsap.to(this.canvas, {scrollTo: {x: left}})
        else gsap.set(this.canvas, {scrollTo: {x: left}})
    },

    reset() {
        Building.svg && Building.svg.removeAttr('style');
        this.canvas.removeAttr('style');
        this.canvas.find('.scene').removeAttr('style');
        this.canvas.parent('.background').removeAttr('style');
        this.front.removeAttr('style');
        this.middle.removeAttr('style');
        this.back.removeAttr('style');
        this.headline.find('.holder').removeAttr('style');
    }

}

export default BannerParallax;
window.BannerParallax = BannerParallax;